import React, { useEffect, useState, useCallback, useRef } from 'react'
import { Button } from '@mui/material'
import { useNavigate, Link } from "@reach/router"
import userStore from '../common/userStore'
import useTitle from '../../hooks/title'
import useSchema from '../../hooks/schema'
import Header from '../header/Header'
import AuthHeader from '../layout/AuthHeader'
import classes from './VocalNet.module.scss'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import {ReactComponent as Affiliate} from '../../images/affiliate.svg'
import {ReactComponent as AffiliateBlack} from '../../images/affiliate-black.svg'
import {ReactComponent as Windows} from '../../images/windows.svg'
import {ReactComponent as Mac} from '../../images/mac.svg'
import useWindowSize from '../../hooks/window-size';
import Footer from '../footer/FooterBlack'
import clsx from 'clsx'
import Backdrop from '@mui/material/Backdrop';
import {createApi} from "../common/API";
import layoutStyles from '../layout/Layout.module.scss'
import { scroll } from '../../utils'
import { useLocation } from "@reach/router"
import pcMp4 from '../../images/pc/vocalnet.mp4'
import mbMp4 from '../../images/mb/vocalnet.mp4'
import tutorial1 from '../../images/pc/vocalnet1.mp4'
import tutorial2 from '../../images/pc/vocalnet2.mp4'
import tutorial3 from '../../images/pc/vocalnet3.mp4'
import vocalnetMapImg from '../../images/pc/vocalnet.png'
import vocalnetArtistMapImg from '../../images/pc/vocalnet-artist.png'
import araImg from '../../images/ara.png'
// Inputs
import src0 from '../../audios/src1.mp3';
import src1 from '../../audios/src2.mp3';
import src2 from '../../audios/src3.mp3';

// Targets
import ref0 from '../../audios/ref1.mp3';
import ref1 from '../../audios/ref2.mp3';
import ref2 from '../../audios/ref3.mp3';

// Outputs
import out0 from '../../audios/out1.mp3';
import out1 from '../../audios/out2.mp3';
import out2 from '../../audios/out3.mp3';

// Artist images
import belaroImg from '../../images/artists/belaro.jpg';
import blackbirdImg from '../../images/artists/blackbird.jpg';
import boyBeverlyImg from '../../images/artists/boy-beverly.jpg';

// Social icons
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import {ReactComponent as TikTokIcon} from '../../images/tiktok.svg';
import {ReactComponent as SpotifyIcon} from '../../images/spotify.svg';
import {ReactComponent as AppleMusicIcon} from '../../images/apple-music.svg';

const artists = [
    {
        name: 'BELARO',
        title: 'Singer',
        description: 'BELARO, rising R&B star, fuses Y2K-inspired soul with modern edge, delivering powerhouse vocals and viral performances.',
        image: belaroImg,
        socials: {
            instagram: 'https://instagram.com/belaro',
            tiktok: 'https://tiktok.com/@belaro',
            youtube: 'https://youtube.com/@belaro',
            spotify: 'https://open.spotify.com/artist/belaro',
            appleMusic: 'https://music.apple.com/artist/belaro',
        }
    },
    {
        name: 'Blackbird',
        title: 'Artist, Singer, Songwriter',
        description: 'A Cyprus-born musician, unites East and West with Mediterranean beauty and pop energy, crafting cultural pop anew.',
        image: blackbirdImg,
        socials: {
            instagram: 'https://instagram.com/blackbird',
            tiktok: 'https://tiktok.com/@blackbird',
            youtube: 'https://youtube.com/@blackbird',
            spotify: 'https://open.spotify.com/artist/blackbird',
            appleMusic: 'https://music.apple.com/artist/blackbird',
        }
    },
    {
        name: 'Boy Beverly',
        title: 'Singer',
        description: 'From Philly to LA, Boy Beverly channels growth and emotion into music that moves beyond sound into shared experience.',
        image: boyBeverlyImg,
        socials: {
            instagram: 'https://instagram.com/boybeverly',
            tiktok: 'https://tiktok.com/@boybeverly',
            youtube: 'https://youtube.com/@boybeverly',
            spotify: 'https://open.spotify.com/artist/boybeverly',
            appleMusic: 'https://music.apple.com/artist/boybeverly',
        }
    },
];

const comparisonProducts = [
    { name: 'VocalNet' },
    { name: 'SoundID AI Voice Changer' },
    { name: 'IK Multimedia ReSing' },
];
const comparisonRows = [
    { feature: 'Real Time Processing', values: ['Yes', 'No', 'No'] },
    { feature: 'Works in all DAWS', values: ['Yes', 'Yes', 'No'] },
    { feature: 'Real Artists', values: ['Yes', 'No', 'Yes'] },
    { feature: 'ARA Mode', values: ['Yes', 'No', 'Yes'] },
    { feature: 'Voice Morph', values: ['Yes', 'No', 'No'] },
];

const faqItems = [
    {
        question: 'What is VocalNet?',
        answer: 'VocalNet is an AI voice transformation plugin for music producers. It can transform a vocal performance in real time, clone a target voice from imported samples, blend voices, or use licensed artist voice models.'
    },
    {
        question: 'Is VocalNet a real-time AI voice changer?',
        answer: 'Yes. VocalNet can process vocals in real time inside your DAW, so you can hear the transformed voice during playback instead of waiting for an offline render.'
    },
    {
        question: 'Which plugin formats and DAWs does VocalNet support?',
        answer: 'VocalNet is available for Windows and Mac. The Windows installer includes VST3 and AAX, while the Mac installer includes VST3, AU, and AAX. It is designed for DAW workflows that support those plugin formats.'
    },
    {
        question: 'Does VocalNet support ARA mode?',
        answer: 'Yes. VocalNet supports ARA workflows in compatible DAWs, which lets you work more directly on the timeline with tighter editing integration.'
    },
    {
        question: 'How long should a voice sample be for cloning?',
        answer: 'For best results, use clean and lightly processed voice samples that are about 5 to 10 seconds long. Cleaner source audio usually produces better voice transformations.'
    },
    {
        question: 'Can VocalNet morph between voices?',
        answer: 'Yes. VocalNet includes Blend Mode, which lets you load up to three voices and morph between them to create a custom vocal tone.'
    },
    {
        question: 'Can I try VocalNet before buying?',
        answer: 'Yes. You can try all features for 14 days. After the trial period, Voice Cloning is disabled unless you purchase a lifetime license or subscribe to a plan.'
    },
    {
        question: 'What is included with a VocalNet purchase?',
        answer: 'The one-time VocalNet purchase gives you VocalNet only, paid once and used forever. Subscription plans start at $5.99 per month and include everything in a bundle except artist models.'
    }
];

const showApp = createApi('/app/getApps', {method: 'POST', expandData: true, notify: true, noThrow: false});

const VocalNet = () => {
    useTitle("VocalNet — AI Voice Transformation Plugin (Free Trial)", "Transform any vocal in real time with AI. Change timbre, pitch, and style instantly, or clone artist voices. Free 14-day trial — download the VST plugin for Windows and Mac.", "/vocalnet")
    const [version, setVersion] = useState('');
    const [price, setPrice] = useState('');
    useSchema({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "SoftwareApplication",
          "name": "VocalNet",
          "description": "Real-time AI voice cloning and transformation VST plugin. Clone voices from samples, blend up to three voices, or use licensed artist voices. Supports ARA workflows, VST3, AU, and AAX formats.",
          "url": "https://sessionloops.com/vocalnet",
          "applicationCategory": "MusicApplication",
          "operatingSystem": "Windows 10 or later, macOS 10.15 or later",
          "softwareVersion": version || undefined,
          "screenshot": "https://sessionloops.com/static/media/vocalnet.png",
          "featureList": [
            "Real-time AI voice transformation",
            "Voice cloning from imported samples",
            "Blend Mode: morph between up to 3 voices",
            "Artist Mode: licensed artist voice models",
            "ARA workflow support",
            "VST3, AU, AAX plugin formats",
            "14-day free trial"
          ],
          "offers": [
            {
              "@type": "Offer",
              "name": "One-time Purchase — Limited-Time Offer",
              "price": price || "49",
              "priceCurrency": "USD",
              "availability": "https://schema.org/InStock",
              "url": "https://sessionloops.com/account/app-buy?app-id=VocalNet"
            },
            {
              "@type": "Offer",
              "name": "Subscription",
              "price": "5.99",
              "priceCurrency": "USD",
              "availability": "https://schema.org/InStock",
              "url": "https://sessionloops.com/pricing"
            }
          ],
          "publisher": {
            "@type": "Organization",
            "name": "Session Loops",
            "url": "https://sessionloops.com",
            "logo": "https://sessionloops.com/logo.png"
          },
          "review": {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Man Parrish"
            },
            "reviewBody": "I really like your approach! The output sounds clean, it's easy to use, and it just works!",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            }
          }
        },
        {
          "@type": "VideoObject",
          "name": "How VocalNet Works — AI Voice Transformation Tutorial",
          "description": "Learn how VocalNet's real-time AI voice cloning and transformation plugin works inside your DAW.",
          "thumbnailUrl": "https://img.youtube.com/vi/zIMh8gt_ucU/maxresdefault.jpg",
          "embedUrl": "https://www.youtube.com/embed/zIMh8gt_ucU",
          "uploadDate": "2024-01-01",
          "publisher": {
            "@type": "Organization",
            "name": "Session Loops",
            "logo": {
              "@type": "ImageObject",
              "url": "https://sessionloops.com/logo.png"
            }
          }
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://sessionloops.com/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "VocalNet",
              "item": "https://sessionloops.com/vocalnet"
            }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": faqItems.map(item => ({
            "@type": "Question",
            "name": item.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": item.answer
            }
          }))
        }
      ]
    })
    const [winUrl, setWinUrl] = useState('');
    const [macUrl, setMacUrl] = useState('');
    const navigate = useNavigate();
    const windowSize = useWindowSize();
    const [isPlaying, setIsPlaying] = useState(false);
    const playerRef = useRef(null);
    const [isAffiliateHover, setIsAffiliateHover] = useState(false);
    const [activeDot, setActiveDot] = useState(null);
    const [activeComparisonIndex, setActiveComparisonIndex] = useState(0);
    const [comparisonDirection, setComparisonDirection] = useState('next');
    const [activeFaqIndex, setActiveFaqIndex] = useState(null);
    const comparisonTouchStartX = useRef(null);
    const dots = [
        { id: 'voice',     top: '21.3%', left: 'calc(50% - 6px)', title: 'Load Voice', desc: 'Load presets or import voice samples into slots. VocalNet analyzes them and converts your input to match the target voice. You can load up to three voices. For best results, use samples 5–10 seconds long.' },
        { id: 'cursor', top: '54%', left: 'calc(50% - 6px)', title: 'Morph Between Voices', desc: 'Drag the cursor to blend voices into a unique tone.' },
        { id: 'mode', top: '6%', left: '83%', title: 'Select Render Mode', desc: 'Choose Capture Mode for real-time conversion, or File Mode to render offline with the best quality.' },
         { id: 'switch', top: '6%', left: 'calc(50% - 6px)', title: 'Switch Mode', desc: 'Move cursor here to switch between Blend Mode and Artist Mode' },
    ];
    const artistDots = [
        { id: 'artist',     top: '16.3%', left: 'calc(50% - 6px)', title: 'Switch Artists', desc: 'Choose My Artists to view voices you have installed or purchased. Choose All Artists to browse every available artist, including free voices.' },
        { id: 'buy', top: '53%', left: '83%', title: 'Purchase Artist', desc: 'Click the button to open the purchase page for the selected artist voice.' },
        { id: 'redeem', top: '16%', left: '83%', title: 'Redeem Artist', desc: 'After purchase, click the button and paste your redemption code in the popup to unlock the artist voice.' },
    ];

    const isNearTop = (topPercent) => {
        const topValue = parseInt(topPercent);
        return topValue < 30; // If dot is in top 30% of the map
    };

    const handlePlayClick = () => {
        if (windowSize.width < 500)
        setIsPlaying(true);
    };

    const handleOverlayClick = (e) => {
        
        // Check if the click occurred outside the iframe
        if (playerRef.current && !playerRef.current.contains(e.target)) {
            setIsPlaying(false);
        }
        if (isPlaying) 
            setIsPlaying(false);
    };

    const handleMapClick = (e) => {
        // Close tooltip if clicking on the map but not on a dot or tooltip
        if (e.target.classList.contains(classes.map)) {
            setActiveDot(null);
        }
    };

    const handleTooltipClick = (e) => {
        // Prevent tooltip from closing when clicking inside it
        e.stopPropagation();
    };

    const selectComparisonProduct = (index) => {
        setComparisonDirection(index > activeComparisonIndex ? 'next' : 'prev');
        setActiveComparisonIndex(index);
    };

    const handleComparisonTouchStart = (e) => {
        comparisonTouchStartX.current = e.touches[0].clientX;
    };

    const handleComparisonTouchEnd = (e) => {
        if (comparisonTouchStartX.current === null) return;

        const deltaX = e.changedTouches[0].clientX - comparisonTouchStartX.current;
        comparisonTouchStartX.current = null;

        if (Math.abs(deltaX) < 42) return;

        if (deltaX < 0 && activeComparisonIndex < comparisonProducts.length - 1) {
            selectComparisonProduct(activeComparisonIndex + 1);
        }
        if (deltaX > 0 && activeComparisonIndex > 0) {
            selectComparisonProduct(activeComparisonIndex - 1);
        }
    };

    const location = useLocation();
    useEffect(() => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        const isAndroid = /Android/i.test(ua);
        const isChrome = /Chrome\//.test(ua) && !/Edg\//.test(ua) && !/OPR\//.test(ua) && !/SamsungBrowser\//.test(ua) && !/UCBrowser\//.test(ua) && !/CriOS\//.test(ua);
        const isAndroidChrome = isAndroid && isChrome;
        if (isAndroidChrome) {
            document.body.classList.add('android-chrome');
        }
        return () => {
            document.body.classList.remove('android-chrome');
        }
    }, []);
    useEffect(() => {
        //console.log('hash', window.location.hash)
        if (window.location.hash) {
            let dom = document.getElementById(window.location.hash.replace('#', ''));
            dom && dom.scrollIntoView({block:"center", behavior:"smooth"})
        } else {
            window.scrollTo(0, 0)
        }
        const fetchApiData = async () => {
            try {
              const response = await showApp();
              setVersion(response[4].version)
              setPrice(response[4].price)
              setMacUrl(response[4].macUrl)
              setWinUrl(response[4].winUrl)
            } catch (error) {
              console.error('Error fetching API data:', error);
            }
          };
        fetchApiData()
    }, [location.pathname])

    const mp4 = windowSize.width > 500 ? pcMp4 : mbMp4;

    const rows = [
    [src0, ref0, out0],
    [src1, ref1, out1],
    [src2, ref2, out2],
    ];

    const audioRefs = useRef([]);          // holds DOM <audio> elements
    const [playingIndex, setPlayingIndex] = useState(-1);

    const handlePlay = (idx) => {
    audioRefs.current.forEach((a, i) => {
        if (a && i !== idx) {
        a.pause();
        a.currentTime = 0;
        }
    });
    setPlayingIndex(idx);
    };

    const handleEnded = () => setPlayingIndex(-1);
      
      useEffect(() => {
        const handleEnded = () => setPlayingIndex(-1);
        const audios = audioRefs.current;
        audios.forEach(a => a && a.addEventListener("ended", handleEnded));
        return () => {
          audios.forEach(a => a && a.removeEventListener("ended", handleEnded));
        };
      }, []);
      
      const togglePlay = (index) => {
        const audios = audioRefs.current;
        audios.forEach((a, i) => {
          if (i !== index) {
            a.pause();
            a.currentTime = 0;
          }
        });
        const audio = audios[index];
        if (playingIndex === index) {
          audio.pause();
          audio.currentTime = 0; // stop instead of pause
          setPlayingIndex(-1);
        } else {
          audio.play();
          setPlayingIndex(index);
        }
      };

    return <div className={clsx(classes.root, layoutStyles.root)}>
      {userStore.isAnonymous ? <Header/> : <AuthHeader />}
    <div className={classes.seg}>
        <video autoPlay loop muted playsInline>
            <source src={mp4} type="video/mp4" />
        </video>

        <div className={classes.introduction}>
            <h1>VocalNet</h1>
            <p>Real-Time Voice Cloning & Transformation Plugin</p>
        </div>
    </div>
      <Backdrop open={isPlaying} onClick={handleOverlayClick} />
        <div className={classes.options} >
            <div className={clsx(classes.option, classes.white)}  style={windowSize.width < 500 ? {paddingLeft: 'calc(35vw + 2px)'} : {}}
                onClick = {() => document.getElementById("buys").scrollIntoView({block:"center", behavior:"smooth"})}>
                <ShoppingCartIcon/>
                <div className={classes.optionText} style={windowSize.width < 500 ? {marginLeft : 22} : {}}>Buy Now</div>
            </div>
            <div className={clsx(classes.option, classes.white)} style={windowSize.width < 500 ? {borderTop: '1.5px solid white', borderBottom: '1.5px solid white'} :
            {borderLeft: '1.5px solid white', borderRight: '1.5px solid white'}}
                onClick = {() => document.getElementById("downloads").scrollIntoView({block:"center", behavior:"smooth"})}
            >
                <SaveAltIcon style={{fontSize: 28}}/>
                <div className={classes.optionText}>{windowSize.width < 500 ? 'Download' : 'Download Free'}</div>
            </div>
            <a className={clsx(classes.option, classes.white)} style={{textDecoration: 'none'}} href="https://docs.google.com/forms/d/e/1FAIpQLSeJN0g9b8i4WFSuo6LsaH54Wz-Ax7KIitov_h4Bbz5T6Gwa4w/viewform?usp=sharing&ouid=111966021963431537990"  target="_blank"
                onMouseEnter={() => setIsAffiliateHover(true)}
                onMouseLeave={() => setIsAffiliateHover(false)}
            >
                {isAffiliateHover ? <AffiliateBlack style={{width: 27, height: 27}}/> : <Affiliate style={{width: 27, height: 27}}/>}
                <div className={classes.optionText}>{windowSize.width < 500 ? 'Join Our Artists' : 'Join Our Artists'}</div>
            </a>
        </div>
        <div className={classes.content}>
            <div className={classes.walkthrough}>
                <div className={classes.title}>How VocalNet works</div>
                <div className={classes.videoContainer}>
                    <iframe
                        src="https://www.youtube.com/embed/zIMh8gt_ucU?si=lDriZ9VSSocrWESI"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    />
                </div>
                <div className={classes.subTitle} style={{marginTop: 60}}>Choose Between Two Modes</div>
                <div className={classes.tutorial} style={{marginTop: windowSize.width < 500 ? 60 : 120}} >
                    <div
                        className={classes.map}
                        style={{ backgroundImage: `url(${vocalnetMapImg})` }}
                        onClick={handleMapClick}
                    >
                        {dots.map(dot => (
                            <div key={dot.id}
                                className={classes.dot}
                                style={{ top: dot.top, left: dot.left }}
                                onClick={() => setActiveDot(activeDot === dot.id ? null : dot.id)}
                            />
                        ))}
                        {dots.map(dot => (
                            activeDot === dot.id ? (
                                <div key={dot.id + '-tip'}
                                    className={clsx(classes.tooltip, isNearTop(dot.top) && classes.tooltipBelow)}
                                    style={{ top: dot.top, left: dot.left }}
                                    onClick={handleTooltipClick}
                                >
                                    <div className={classes.title}>{dot.title}</div>
                                    <div className={classes.desc}>{dot.desc}</div>
                                </div>
                            ) : null
                        ))}
                    </div>
                    <div className={classes.tutorialText}>
                        <div className={classes.tutorialTitle}>Blend Mode</div>
                        <div className={classes.tutorialDesc}>
                            Load up to three voices, then drag the cursor to blend them into a unique tone in real time.
                        </div>
                    </div>
                </div>
                <div className={classes.tutorial} style={{marginTop: windowSize.width < 500 ? 60 : 120}} >
                    <div
                        className={clsx(classes.map, classes.mapArtist)}
                        style={{ backgroundImage: `url(${vocalnetArtistMapImg})` }}
                        onClick={handleMapClick}
                    >
                        {artistDots.map(dot => (
                            <div key={dot.id}
                                className={classes.dot}
                                style={{ top: dot.top, left: dot.left }}
                                onClick={() => setActiveDot(activeDot === dot.id ? null : dot.id)}
                            />
                        ))}
                        {artistDots.map(dot => (
                            activeDot === dot.id ? (
                                <div key={dot.id + '-tip'}
                                    className={clsx(classes.tooltip, isNearTop(dot.top) && classes.tooltipBelow)}
                                    style={{ top: dot.top, left: dot.left }}
                                    onClick={handleTooltipClick}
                                >
                                    <div className={classes.title}>{dot.title}</div>
                                    <div className={classes.desc}>{dot.desc}</div>
                                </div>
                            ) : null
                        ))}
                    </div>
                    <div className={classes.tutorialText}>
                        <div className={classes.tutorialTitle}>Artist Mode</div>
                        <div className={classes.tutorialDesc}>
                            Try voices from our collaborating artists free for 14 days. If one fits your project, purchase it - most of the revenue goes directly to the artist.
                        </div>
                    </div>
                </div>
                {/* <iframe className={classes.embedded} src="https://www.youtube.com/embed/JvAU_GTQsDo?si=veIyymD16qJMRTXT" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe> */}
            </div>
            <div className={classes.subTitle}>Clone & Transform Voices in <br/>Three Steps</div>
            <div className={classes.tutorial}>
                <div className={classes.tutorialVideo}>
                    <video className={classes.videoFrame} autoPlay loop muted playsInline>
                        <source src={tutorial1} type="video/mp4" />
                    </video>
                </div>
                <div className={classes.tutorialText}>
                    <div className={classes.tutorialTitle}>1. Import Voice Samples</div>
                    <div className={classes.tutorialDesc}>
                        VocalNet analyzes the imported samples and clones them as target voices. The cleaner and less processed the samples, the higher the quality of the transformations.
                    </div>
                </div>
            </div>

            <div className={classes.tutorial}>
                {windowSize.width < 500 ? 
                <React.Fragment>
                <div className={classes.tutorialVideo}>
                <video className={classes.videoFrame} autoPlay loop muted playsInline>
                    <source src={tutorial2} type="video/mp4" />
                </video>
                </div>
                <div className={classes.tutorialText}>
                    <div className={classes.tutorialTitle} style={{textAlign: 'left'}}>2. Transform Input Voice</div>
                    <div className={classes.tutorialDesc} style={{textAlign: 'left'}}>
                        Start playback on your audio track — VocalNet will convert the input in real time to match the target voices as an audio effect.
                    </div>
                </div></React.Fragment> : 
                <React.Fragment>
                <div className={classes.tutorialText}>
                    <div className={classes.tutorialTitle} style={{textAlign: 'right'}}>2. Transform Input Voice</div>
                    <div className={classes.tutorialDesc} style={{textAlign: 'right'}}>
                        Start playback on your audio track — VocalNet will convert the input in real time to match the target voices as an audio effect.
                    </div>
                </div>
                <div className={classes.tutorialVideo}>
                    <video className={classes.videoFrame} autoPlay loop muted playsInline>
                        <source src={tutorial2} type="video/mp4" />
                    </video>
                </div></React.Fragment>}
            </div>

            <div className={classes.tutorial}>
                <div className={classes.tutorialVideo}>
                    <video className={classes.videoFrame} autoPlay loop muted playsInline>
                        <source src={tutorial3} type="video/mp4" />
                    </video>
                </div>
                <div className={classes.tutorialText}>
                    <div className={classes.tutorialTitle}>3. Morph Between Voices</div>
                    <div className={classes.tutorialDesc}>
                        Load up to three voices, then drag the cursor to blend them into a unique tone in real time.
                    </div>
                </div>
            </div>
            <div className={classes.subTitle}>Full DAW Integration with ARA Support</div>
            <div className={classes.araSection}>
                <img src={araImg} alt="Full DAW Integration with ARA Support" className={classes.araImage} />
                <div className={classes.araDescription}>
                    VocalNet supports ARA workflows for compatible DAWs, so you can work directly on your track timeline with faster, tighter integration and a smoother editing experience.
                </div>
            </div>
            <div className={classes.subTitle}>Hear It in Action</div>
            <div className={classes.audioGrid}>
            {windowSize.width > 900 && (
                <div className={classes.audioHead}>
                <div className={classes.audioColTitle}>Input</div>
                <div className={classes.audioColTitle}>Target</div>
                <div className={classes.audioColTitle}>Output</div>
                </div>
            )}
            {[0, 1, 2].map(r => (
                <div key={r} className={classes.audioRowWrap}>
                {windowSize.width <= 900 && (
                    <div className={classes.audioColTitle}>Input</div>
                )}
                <audio
                    className={classes.audioPlayer}
                    controls
                    controlsList="nodownload noplaybackrate noremoteplayback"
                    src={[src0, src1, src2][r]}
                    ref={el => (audioRefs.current[r * 3 + 0] = el)}
                    onPlay={() => handlePlay(r * 3 + 0)}
                    onEnded={handleEnded}
                />
                {windowSize.width <= 900 && (
                    <div className={classes.audioColTitle}>Target</div>
                )}
                <audio
                    className={classes.audioPlayer}
                    controls
                    controlsList="nodownload noplaybackrate noremoteplayback"
                    src={[ref0, ref1, ref2][r]}
                    ref={el => (audioRefs.current[r * 3 + 1] = el)}
                    onPlay={() => handlePlay(r * 3 + 1)}
                    onEnded={handleEnded}
                />
                {windowSize.width <= 900 && (
                    <div className={classes.audioColTitle}>Output</div>
                )}
                <audio
                    className={classes.audioPlayer}
                    controls
                    controlsList="nodownload noplaybackrate noremoteplayback"
                    src={[out0, out1, out2][r]}
                    ref={el => (audioRefs.current[r * 3 + 2] = el)}
                    onPlay={() => handlePlay(r * 3 + 2)}
                    onEnded={handleEnded}
                />
                </div>
            ))}
            </div>
            {/* <div className={classes.subTitle}>Meet the Humans Behind the Models</div> */}
            {/* <div className={classes.artistsSection}>
                <div className={classes.artistsGrid}>
                    {artists.map((artist, index) => (
                        <div key={index} className={classes.testimonial}>
                            <div className={classes.artistImageWrapper}>
                                <img src={artist.image} alt={artist.name} className={classes.artistImage} />
                            </div>
                            <div className={classes.testimonialContent}>
                                <div className={classes.testimonialName}>{artist.name}</div>
                                <div className={classes.testimonialTitle}>{artist.title}</div>
                                {artist.description}
                            </div>
                            <div className={classes.artistSocials}>
                                <a href={artist.socials.instagram} target="_blank" rel="noopener noreferrer">
                                    <InstagramIcon className={classes.socialIcon} />
                                </a>
                                <a href={artist.socials.tiktok} target="_blank" rel="noopener noreferrer">
                                    <TikTokIcon className={classes.socialIcon} />
                                </a>
                                <a href={artist.socials.youtube} target="_blank" rel="noopener noreferrer">
                                    <YouTubeIcon className={classes.socialIcon} />
                                </a>
                                <a href={artist.socials.spotify} target="_blank" rel="noopener noreferrer">
                                    <SpotifyIcon className={classes.socialIcon} />
                                </a>
                                <a href={artist.socials.appleMusic} target="_blank" rel="noopener noreferrer">
                                    <AppleMusicIcon className={classes.socialIcon} />
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div> */}
            <div className={classes.subTitle}>How VocalNet Compares</div>
            <div className={classes.comparisonSection}>
                <div className={classes.comparisonTabs} role="tablist" aria-label="Select product to compare">
                    <div
                        className={classes.comparisonTabIndicator}
                        style={{transform: `translateX(${activeComparisonIndex * 100}%)`}}
                    />
                    {comparisonProducts.map((product, index) => (
                        <button
                            key={product.name}
                            type="button"
                            role="tab"
                            aria-selected={activeComparisonIndex === index}
                            className={clsx(classes.comparisonTab, activeComparisonIndex === index && classes.comparisonTabActive)}
                            onClick={() => selectComparisonProduct(index)}
                        >
                            {product.name}
                        </button>
                    ))}
                </div>
                <div className={classes.comparisonMatrix}>
                    <table className={classes.comparisonTable}>
                        <caption className={classes.comparisonCaption}>
                            VocalNet comparison with SoundID AI Voice Changer and IK Multimedia ReSing.
                        </caption>
                        <thead>
                            <tr className={classes.comparisonProductRow}>
                                <th aria-hidden="true"></th>
                                {comparisonProducts.map(product => (
                                    <th key={product.name} scope="col" className={classes.comparisonProduct}>
                                        {product.name}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {comparisonRows.map(row => (
                                <tr key={row.feature}>
                                    <th scope="row" className={classes.comparisonFeature}>
                                        {row.feature}
                                    </th>
                                    {row.values.map((value, productIndex) => {
                                        const isYes = value === 'Yes';
                                        const isNo = value === 'No';

                                        return (
                                            <td key={`${row.feature}-${comparisonProducts[productIndex].name}`} className={classes.comparisonItem}>
                                                <span
                                                    className={clsx(
                                                        classes.comparisonValue,
                                                        isYes && classes.comparisonYes,
                                                        isNo && classes.comparisonNo
                                                    )}
                                                    aria-label={`${comparisonProducts[productIndex].name} ${row.feature}: ${value}`}
                                                >
                                                    {isYes ? '✓' : isNo ? '×' : value}
                                                </span>
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div
                    className={classes.comparisonMobileMatrix}
                    onTouchStart={handleComparisonTouchStart}
                    onTouchEnd={handleComparisonTouchEnd}
                >
                    <table
                        key={activeComparisonIndex}
                        className={clsx(
                            classes.comparisonMobileTable,
                            comparisonDirection === 'next' ? classes.comparisonMobileTableNext : classes.comparisonMobileTablePrev
                        )}
                    >
                        <caption className={classes.comparisonCaption}>
                            {comparisonProducts[activeComparisonIndex].name} comparison details.
                        </caption>
                        <tbody>
                            {comparisonRows.map(row => {
                                const value = row.values[activeComparisonIndex];
                                const isYes = value === 'Yes';
                                const isNo = value === 'No';

                                return (
                                    <tr key={`${comparisonProducts[activeComparisonIndex].name}-${row.feature}`}>
                                        <th scope="row" className={classes.comparisonFeature}>
                                            {row.feature}
                                        </th>
                                        <td className={classes.comparisonItem}>
                                            <span
                                                className={clsx(
                                                    classes.comparisonValue,
                                                    isYes && classes.comparisonYes,
                                                    isNo && classes.comparisonNo
                                                )}
                                                aria-label={`${comparisonProducts[activeComparisonIndex].name} ${row.feature}: ${value}`}
                                            >
                                                {isYes ? '✓' : isNo ? '×' : value}
                                            </span>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className={classes.subTitle}>What Industry Pros Say</div>
            <div className={classes.testimonial}>
                <div className={classes.parrish} />
                <div className={classes.testimonialContent}>
                    <div className={classes.testimonialName}>
                    Man Parrish
                    </div>
                    <div className={classes.testimonialTitle}>
                    YMO, Kraftwerk
                    </div>
                I really like your approach! The output sounds clean, it's easy to use, and it just works!
                 </div>
            </div>
            <div className={classes.free} />
            <div id="downloads" className={classes.downloads}>
                <div className={classes.download}>
                    <Button startIcon={<Windows style={{marginLeft: 7, marginRight: 10}}/>} variant="contained" className={classes.button}  href={winUrl} target="_blank">Download for Windows</Button>
                    Version {version}, VST3 & AAX
                </div>
                <div className={classes.download}>
                    <Button startIcon={<Mac style={{marginLeft: 7, marginRight: 10}}/>} variant="contained" className={classes.button}  href={macUrl} target="_blank">Download for Mac</Button>
                    Version {version}, VST3 & AU & AAX, Universal
                </div>
            </div>
            <div className={classes.text}>You can try out all features for 14 days. Afterwards Voice Cloning will be disabled.<br/>To access full version, purchase a lifetime license or subscribe to our plans. </div>
            <div id="buys" className={classes.buys}>
                <div className={classes.buy}>
                    <div className={classes.buyTitle}>One-time<br/>Purchase</div>
                    <div className={classes.buyPrice}>
                        ${price}
                        {/* <div className={classes.priceDiscount}>$99</div>
                        <div className={classes.priceSegment}/>
                        <div className={classes.priceNow}>${price}</div>
                        <div className={classes.priceTag}>Limited-Time<br/>Offer</div> */}
                    </div>
                    <div className={classes.buyDescription}>VocalNet only, pay once, use forever</div>
                    <Button style={{width: 193}} variant="contained" className={classes.button}  onClick={() => navigate('/account/app-buy?app-id=VocalNet')}>Buy VocalNet</Button>
                </div>
                <div className={classes.buy} style={{width: 361, marginLeft: windowSize.width < 500 ? 0 : 93}}>
                    <div className={classes.buyTitle}>Subscription<br/>( 14 days free trial )</div>
                    <div className={classes.buyPrice}>
                        <div style={{color: '#F3FEFF'}} className={classes.priceSubscription}>Starts from</div>
                        <div style={{position: 'static', marginLeft: 10, marginRight: 30}} className={classes.priceNow}>$5.99</div>
                        <div className={classes.priceSubscription}>/ mo</div>
                    </div>
                    <div className={classes.buyDescription}>Everything in a bundle except artist models</div>
                    <Button style={{width: 193}} variant="contained" className={classes.button}  onClick={() => navigate('/pricing')}>See Plans</Button>
                </div>
                <div className={classes.buySegment1}/>
                <div className={classes.buySegment2}/>
            </div>
            <div className={classes.faqSection}>
                <div className={classes.subTitle}>VocalNet FAQ</div>
                <div className={classes.faqList}>
                    {faqItems.map((item, index) => (
                        <div key={item.question} className={classes.faqItem}>
                            <button
                                type="button"
                                className={classes.faqQuestion}
                                aria-expanded={activeFaqIndex === index}
                                aria-controls={`vocalnet-faq-${index}`}
                                onClick={() => setActiveFaqIndex(activeFaqIndex === index ? null : index)}
                            >
                                <span>{item.question}</span>
                                <span className={clsx(classes.faqIcon, activeFaqIndex === index && classes.faqIconOpen)} />
                            </button>
                            <div
                                id={`vocalnet-faq-${index}`}
                                className={clsx(classes.faqAnswer, activeFaqIndex === index && classes.faqAnswerOpen)}
                            >
                                <p>{item.answer}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
        <Footer />
      </div>
  }

  export default VocalNet
